var _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperatorGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#C1C3C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatorGrey);
export default __webpack_public_path__ + "static/media/operator-grey.891e4717b99f3e112a22a19eb3f35f13.svg";
export { ForwardRef as ReactComponent };